var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FinishTime",class:_vm.styling},[_vm._v(" "+_vm._s(_vm.prettyTime)+" "),(_vm.bonusSeconds > 0)?_c('span',{staticStyle:{"font-size":"59%"}},[_vm._v(" (+ "+_vm._s(_vm.bonusSeconds)+")")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }